import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  signup,
  getCountryList,
  getIsabelCountryList,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import $, { data } from "jquery";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import "select2";
import "select2/dist/css/select2.min.css";
import countryData from "../../../assets/json/countries.json";
import { SignupConfirmation } from "../../../modal/signupconfirmationPop";
import AWS from "aws-sdk";

function NormalSignUp() {
  const [phone, setPhone] = useState("");
  const [signupConfirm, setSignupConfirm] = useState(false);
  const [phoneDial, setPhoneDial] = useState("");
  const [countryName, setCountryName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [role, setRole] = useState("1"); // Initial role state
  const [referralSource, setReferralSource] = useState("Media"); // Initial role state
  const [showLicenseInput, setShowLicenseInput] = useState(false); // State to show/hide license input
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showReferalInput, setShowReferalInput] = useState(false);
  const [cpasswordVisible, setCpasswordVisible] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isabelCountryList, setIsabelCountryList] = useState(countryData);
  const [selectedFile, setSelectedFile] = useState(null);
  const [priestInfo, setPriestInfo] = useState({
    organization_name: "",
    bio: "",
  });
  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };

      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          console.log("err, data-->", err, data);
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      let fileType = file.name.split(".").pop();

      // let imgUrl = "";
      await uploadData(file, "/verification_document")
        .then((newImage) => {
          Swal.close();
          console.log(
            "verification_document",
            `https://msh-dev.s3.amazonaws.com/verification_document/${newImage}`
          );
          // imgUrl = newImage;
          setSelectedFile(
            `https://msh-dev.s3.amazonaws.com/verification_document/${newImage}`
          );
        })
        .catch((e) => {
          Swal.close();
        });
    }
  };
  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };
  const toggleCpasswordVisibility = () => {
    setCpasswordVisible((prev) => !prev);
  };
  const handlePhoneChange = (value, data) => {
    console.log(value, "asdfasd", data.dialCode);
    // setSelectedCountry({
    //   label: response.data[0].calling_code,
    //   value: response.data[0].name
    // });
    setPhoneDial(value);
    const phoneNumberWithoutDialCode = value.replace(`${data.dialCode}`, "");
    setCountryName(data.name);
    setCountryCode(data.dialCode);
    setPhone(phoneNumberWithoutDialCode); // Update the state when phone number changes
  };
  useEffect(() => {
    getCountryList({}).then((response) => {
      response = JSON.parse(response);
      if (response.data.length > 0) {
        setSelectedCountry({
          label: response.data[0].calling_code,
          value: response.data[0].name,
        });
      }
      if (response.code == process.env.REACT_APP_SUCCESS) {
        response.data.map((item) => {
          const countryListObj = {
            label: item.calling_code,
            value: item.name,
          };
          setCountryList((prevState) => [...prevState, countryListObj]);
        });
        // setCountryList(response.data)
      }
    });

    getIsabelCountryList({}).then((response) => {
      response = JSON.parse(response);
      console.log("response: ", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setIsabelCountryList(response.data);
      }
      Swal.close();
    });
  }, []);

  const handleRoleChange = (event) => {
    setRole(event.target.value);
    setShowLicenseInput(
      event.target.value === "2" || event.target.value === "3"
    );
  };

  const handleReferralSourceChange = (event) => {
    setReferralSource(event.target.value);
    setShowReferalInput(event.target.value === "Referral");
  };

  const handleCountryChange = (data) => {
    setSelectedCountry(data);
  };

  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter valid email")
      .required("Please enter email"),
    first_name: Yup.string().required("Please enter first name"),
    middle_name: Yup.string().required("Please enter middle name"),
    last_name: Yup.string().required("Please enter last name"),

    password: Yup.string()
      .required("Please enter password")
      .min(6, "Password must be at least 6 characters"),
    confirmPassword: Yup.string()
      .required("Please enter confirm password")
      .oneOf(
        [Yup.ref("password"), null],
        "Password and confirm password does not match"
      ),
    licenseNumber: Yup.string().when("role", {
      is: (value) => value === "2" || value === "3",
      then: Yup.string().required("Please enter license number"),
      otherwise: Yup.string(),
    }),

    referalNumber: Yup.string().when("referral_source", {
      is: (value) => value === "Referral",
      then: Yup.string().required("Please enter Referral Name"),
      otherwise: Yup.string(),
    }),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors } = formState;

  const onSubmit = (data) => {
    console.log(data.role, "rolerolerolev323");
    if (data?.role === "4") {
      let errors = [];

      if (priestInfo?.bio === "") errors.push("Please enter bio");
      if (priestInfo?.organization_name === "")
        errors.push("Please enter Organization Name");
      if (selectedFile === null)
        errors.push("Please Upload Organization document");

      if (errors.length > 0) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: errors.join("<br/>"), // multiple messages
          toast: true,
          showConfirmButton: false,
          timer: 5000,
        });
        return;
      }
    }

    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    var newData = {
      first_name: data.first_name,
      middle_name: data.middle_name,
      last_name: data.last_name,
      email: data.email,
      password: data.password,
      phone_no: phone,
      role: data.role,
      license_no: data.licenseNumber,
      referType: data.referral_source,
      referName: data.referalNumber,
      country_code: countryCode,
      country: countryName,
      ip: phone,
      bio: priestInfo.bio,
      organization_name: priestInfo.organization_name,
      verification_document: selectedFile,
    };
    if (data.role === "4") {
      delete data?.license_no;
      delete newData?.license_no;
    }

    console.log(newData, "newDatasingup");

    signup(newData).then((res) => {
      Swal.close();
      var response = JSON.parse(res);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 5000,
        });

        setSignupConfirm(true);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  return (
    <>
      <SignupConfirmation
        role={role}
        signupConfirm={signupConfirm}
        setSignupConfirm={setSignupConfirm}
      />
      <form
        className="form-horizontal m-t-30"
        onSubmit={handleSubmit(onSubmit)}
      >
        <main className="">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-6 col-xl-6 col-xxl-5 col-12">
                <div className="login-sec">
                  <div className="logo-size">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/logo--a.png"
                      }
                      alt="logo"
                    />
                  </div>
                  <div className="mb-md-4 mt-md-3">
                    <p className="font_26 font_600 text-center ">Signup Form</p>

                    <div className="text-center mt-3">
                      <Link
                        to="/log-in"
                        className="text-white px-4 d-inline-flex align-items-center justify-center btn rounded"
                        style={{ background: "#fc7c37", fontSize: 13 }}
                      >
                        Already a member? Login here
                      </Link>
                    </div>
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/user.png"
                        }
                        alt="mail"
                      />
                    </span>
                    <input
                      type="text"
                      {...register("first_name")}
                      className="form-control ps-0"
                      id="first_name"
                      placeholder="Enter your first name"
                    />
                    <div className="invalid-feedback">
                      {errors.first_name?.message}
                    </div>
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/user.png"
                        }
                        alt="mail"
                      />
                    </span>
                    <input
                      type="text"
                      {...register("middle_name")}
                      className="form-control ps-0"
                      id="middle_name"
                      placeholder="Enter your middle name"
                    />
                    <div className="invalid-feedback">
                      {errors.middle_name?.message}
                    </div>
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/user.png"
                        }
                        alt="mail"
                      />
                    </span>
                    <input
                      type="text"
                      {...register("last_name")}
                      className="form-control ps-0"
                      id="last_name"
                      placeholder="Enter your last name"
                    />
                    <div className="invalid-feedback">
                      {errors.last_name?.message}
                    </div>
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/mail.png"
                        }
                        alt="mail"
                      />
                    </span>
                    <input
                      type="email"
                      {...register("email")}
                      className="form-control ps-0"
                      id="email"
                      placeholder="Enter your email"
                    />
                    <div className="invalid-feedback">
                      {errors.email?.message}
                    </div>
                  </div>
                  <div className="py-2">
                    {/* disableCountryCode={true} */}
                    <div className="input-group mb-4">
                      <PhoneInput
                        country={"us"}
                        className="border-0"
                        value={phoneDial}
                        onChange={handlePhoneChange} // Handle the phone number change
                      />
                    </div>
                  </div>
                  <div className="input-group mb-4 d-none">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/phone.png"
                        }
                        alt="lock"
                      />
                    </span>
                  </div>
                  <div className="input-group mb-3 d-none">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/icon/map.svg"
                        }
                        alt="mail"
                        style={{ height: "24px", width: "24px" }}
                      />
                    </span>
                    <select
                      className="form-control"
                      {...register("isabel_country_name")}
                    >
                      <option value="">Select Country</option>
                      {isabelCountryList &&
                        isabelCountryList.map((item) => (
                          <option
                            key={item.country_name}
                            value={item.country_id}
                          >
                            {item.country_name}
                          </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">
                      {errors.isabel_country_name?.message}
                    </div>
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/lock.png"
                        }
                        alt="lock"
                      />
                    </span>
                    <input
                      type={passwordVisible ? "text" : "password"}
                      {...register("password")}
                      className="form-control ps-0"
                      id="password"
                      placeholder="Enter your password"
                    />
                    <span
                      className="input-group-text"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={`fa-solid fa-eye${
                          passwordVisible ? "" : "-slash"
                        }`}
                      ></i>
                    </span>
                    <div className="invalid-feedback">
                      {errors.password?.message}
                    </div>
                  </div>
                  <div className="input-group mb-4">
                    <span className="input-group-text ps-0" id="basic-addon1">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/lock.png"
                        }
                        alt="lock"
                      />
                    </span>
                    <input
                      type={cpasswordVisible ? "text" : "password"}
                      {...register("confirmPassword")}
                      className="form-control ps-0"
                      id="confirmPassword"
                      placeholder="Enter your confirm password"
                    />
                    <span
                      className="input-group-text"
                      onClick={toggleCpasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={`fa-solid fa-eye${
                          cpasswordVisible ? "" : "-slash"
                        }`}
                      ></i>
                    </span>
                    <div className="invalid-feedback">
                      {errors.confirmPassword?.message}
                    </div>
                  </div>

                  <div className="mb-4">
                    <p className="mb-2 font_18 font_500">Select role</p>
                    <div className="d-flex gap-3 align-items-center">
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          name="role"
                          {...register("role")}
                          id="patient"
                          value="1"
                          checked={role === "1"}
                          onChange={handleRoleChange}
                        />
                        <label className="form-check-label" htmlFor="patient">
                          Patient
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          name="role"
                          {...register("role")}
                          id="doctor"
                          value="2"
                          checked={role === "2"}
                          onChange={handleRoleChange}
                        />
                        <label className="form-check-label" htmlFor="doctor">
                          Doctor
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          {...register("role")}
                          name="role"
                          id="chemist"
                          value="3"
                          checked={role === "3"}
                          onChange={handleRoleChange}
                        />
                        <label className="form-check-label" htmlFor="chemist">
                          Chemist
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          {...register("role")}
                          name="role"
                          id="priest"
                          value="4"
                          checked={role === "4"}
                          onChange={handleRoleChange}
                        />
                        <label className="form-check-label" htmlFor="priest">
                          Priest
                        </label>
                      </div>
                      <div className="invalid-feedback">
                        {errors.role?.message}
                      </div>
                    </div>
                    {role === "4" && (
                      <>
                        <div className="input-group mb-3">
                          <span
                            className="input-group-text ps-0"
                            id="basic-addon1"
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icon/user.png"
                              }
                              alt="organization name"
                            />
                          </span>
                          <input
                            type="text"
                            onChange={(e) =>
                              setPriestInfo((prev) => ({
                                ...prev,
                                organization_name: e.target.value,
                              }))
                            }
                            value={priestInfo.organization_name}
                            className="form-control ps-0"
                            id="organization_name"
                            placeholder="Enter your organization Name"
                          />
                        </div>

                        <label
                          htmlFor="verification_document"
                          className="text-sm text-muted"
                        >
                          Please upload your verification document
                        </label>
                        <div className="input-group mb-3">
                          <span
                            className="input-group-text ps-0"
                            id="basic-addon1"
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icon/upload-icon.png"
                              }
                              style={{ filter: "grayscale(1)" }}
                              alt="verification_document"
                            />
                          </span>
                          <input
                            type="file"
                            onChange={handleFileUpload}
                            className="form-control ps-0"
                            id="verification_document"
                          />
                        </div>

                        <div className="input-group mb-3">
                          <span
                            className="input-group-text ps-0"
                            id="basic-addon1"
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icon/user.png"
                              }
                              alt="bio"
                            />
                          </span>
                          <input
                            type="text"
                            onChange={(e) =>
                              setPriestInfo((prev) => ({
                                ...prev,
                                bio: e.target.value,
                              }))
                            }
                            value={priestInfo.bio}
                            className="form-control ps-0"
                            id="bio"
                            placeholder="Enter Your bio and LinkedIn."
                          />
                        </div>
                      </>
                    )}

                    {showLicenseInput && (
                      <div id="div1" className="mt-2">
                        <div className="input-group">
                          <div className="form-check ps-0">
                            <input
                              type="text"
                              className="form-control ps-0"
                              {...register("licenseNumber")}
                              name="licenseNumber"
                              id="licenseNumber"
                              placeholder="License number"
                              aria-describedby="basic-addon1"
                            />
                            <div className="invalid-feedback">
                              {errors.licenseNumber?.message}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mb-4">
                    <p className="mb-2 font_18 font_500">
                      How did you learn about Monte Sereno?
                    </p>
                    <div className="d-flex gap-3 align-items-center">
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          name="referral_source"
                          {...register("referral_source")}
                          id="Media"
                          value="Media"
                          checked={referralSource === "Media"}
                          onChange={handleReferralSourceChange}
                        />
                        <label className="form-check-label" htmlFor="Media">
                          Media
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          name="referral_source"
                          {...register("referral_source")}
                          id="Referral"
                          value="Referral"
                          checked={referralSource === "Referral"}
                          onChange={handleReferralSourceChange}
                        />
                        <label className="form-check-label" htmlFor="Referral">
                          Referral
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input radio"
                          type="radio"
                          {...register("referral_source")}
                          name="referral_source"
                          id="Other"
                          value="Other"
                          checked={referralSource === "Other"}
                          onChange={handleReferralSourceChange}
                        />
                        <label className="form-check-label" htmlFor="Other">
                          Other
                        </label>
                      </div>
                      <div className="invalid-feedback">
                        {errors.referral_source?.message}
                      </div>
                    </div>
                  </div>
                  {showReferalInput && (
                    <div id="div1" className="mt-2">
                      <div className="input-group">
                        <div className="form-check ps-0">
                          <input
                            type="text"
                            className="form-control ps-0"
                            {...register("referalNumber")}
                            name="referalNumber"
                            id="referalNumber"
                            placeholder="Please Enter Name"
                            aria-describedby="basic-addon1"
                          />
                          <div className="invalid-feedback">
                            {errors.referalNumber?.message}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <button
                    className="login-btn w-100 border-0 mb-4"
                    type="submit"
                  >
                    Signup
                  </button>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                      checked
                    />
                    <label
                      className="form-check-label font_14"
                      htmlFor="flexCheckChecked"
                    >
                      By continuing, you agree to the{" "}
                      <Link
                        to="/patient/terms"
                        target="_blank"
                        className="text-blue"
                      >
                        Terms of Service
                      </Link>{" "}
                      and{" "}
                      <Link
                        to="/patient/policy"
                        target="_blank"
                        className="text-blue"
                      >
                        Privacy Policy.
                      </Link>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </form>
    </>
  );
}

export default NormalSignUp;
